/**
 * The sort options for articles.
 * Only date fields are supported. Adjust universalGetArticlePagesCompactMultipleEndpoints to support more
 */
export enum ArticlesSort {
  DateDesc = 'publishedAt:desc',
  DateAsc = 'publishedAt:asc',
}

export enum ReferenceArticlesSort {
  RelevanceDesc = 'relevance:desc',
  DateDesc = 'publishedAt:desc',
  DateAsc = 'publishedAt:asc',
}

export interface ArticleFormikValues {
  sort: ArticlesSort | ReferenceArticlesSort;
  tags: ArticleTagsFormikValues | ArticleMixTagsFormikValues;
}

export const defaultArticlesSort = ArticlesSort.DateDesc;
export const defaultArticlesPageSize = 6;

/**
 * The article tags as Formik values
 */
export type ArticleTagsFormikValues = Record<string, string[]>;

/**
 * The article tags as Formik values
 */
export type ArticleMixTagsFormikValues = Record<string, Record<string, string[]>>;

interface ArticleStrapiFiltersAudience {
  key: { $eq: string };
}

export interface ArticleStrapiFiltersTag {
  tags: {
    group: { $eq: string };
    value: { $in: string[] };
  };
}

/**
 * The strapi filter object for articles
 */
export type ArticleStrapiFilters = {
  $and: Array<
    | {
        audiences: ArticleStrapiFiltersAudience;
      }
    | {
        $and: ArticleStrapiFiltersTag[];
      }
  >;
};
